/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchRoleInput
 */
export interface PatchRoleInput {
    /**
     * 
     * @type {string}
     * @memberof PatchRoleInput
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsDailyOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsMainOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsDiscountsAndCoupons?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsMarketingChannelOverview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectAffiliate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectMailing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectOfflineSpends?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectIntegrations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectBilling?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProjectInvitations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchRoleInput
     */
    allowsProfitability?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchRoleInput
     */
    forbiddenChannels?: Array<string> | null;
}

/**
 * Check if a given object implements the PatchRoleInput interface.
 */
export function instanceOfPatchRoleInput(value: object): value is PatchRoleInput {
    return true;
}

export function PatchRoleInputFromJSON(json: any): PatchRoleInput {
    return PatchRoleInputFromJSONTyped(json, false);
}

export function PatchRoleInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchRoleInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'allowsDailyOverview': json['allowsDailyOverview'] == null ? undefined : json['allowsDailyOverview'],
        'allowsMainOverview': json['allowsMainOverview'] == null ? undefined : json['allowsMainOverview'],
        'allowsDiscountsAndCoupons': json['allowsDiscountsAndCoupons'] == null ? undefined : json['allowsDiscountsAndCoupons'],
        'allowsMarketingChannelOverview': json['allowsMarketingChannelOverview'] == null ? undefined : json['allowsMarketingChannelOverview'],
        'allowsProjectProfile': json['allowsProjectProfile'] == null ? undefined : json['allowsProjectProfile'],
        'allowsProjectAffiliate': json['allowsProjectAffiliate'] == null ? undefined : json['allowsProjectAffiliate'],
        'allowsProjectMailing': json['allowsProjectMailing'] == null ? undefined : json['allowsProjectMailing'],
        'allowsProjectOfflineSpends': json['allowsProjectOfflineSpends'] == null ? undefined : json['allowsProjectOfflineSpends'],
        'allowsProjectIntegrations': json['allowsProjectIntegrations'] == null ? undefined : json['allowsProjectIntegrations'],
        'allowsProjectBilling': json['allowsProjectBilling'] == null ? undefined : json['allowsProjectBilling'],
        'allowsProjectUsers': json['allowsProjectUsers'] == null ? undefined : json['allowsProjectUsers'],
        'allowsProjectInvitations': json['allowsProjectInvitations'] == null ? undefined : json['allowsProjectInvitations'],
        'allowsProfitability': json['allowsProfitability'] == null ? undefined : json['allowsProfitability'],
        'forbiddenChannels': json['forbiddenChannels'] == null ? undefined : json['forbiddenChannels'],
    };
}

export function PatchRoleInputToJSON(json: any): PatchRoleInput {
    return PatchRoleInputToJSONTyped(json, false);
}

export function PatchRoleInputToJSONTyped(value?: PatchRoleInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'allowsDailyOverview': value['allowsDailyOverview'],
        'allowsMainOverview': value['allowsMainOverview'],
        'allowsDiscountsAndCoupons': value['allowsDiscountsAndCoupons'],
        'allowsMarketingChannelOverview': value['allowsMarketingChannelOverview'],
        'allowsProjectProfile': value['allowsProjectProfile'],
        'allowsProjectAffiliate': value['allowsProjectAffiliate'],
        'allowsProjectMailing': value['allowsProjectMailing'],
        'allowsProjectOfflineSpends': value['allowsProjectOfflineSpends'],
        'allowsProjectIntegrations': value['allowsProjectIntegrations'],
        'allowsProjectBilling': value['allowsProjectBilling'],
        'allowsProjectUsers': value['allowsProjectUsers'],
        'allowsProjectInvitations': value['allowsProjectInvitations'],
        'allowsProfitability': value['allowsProfitability'],
        'forbiddenChannels': value['forbiddenChannels'],
    };
}

